// extracted by mini-css-extract-plugin
module.exports = {"container":"MovieTemplatePage_container__T8ncA"};